import axios from 'axios'

export const getAllCars = async () =>
    await axios.get(`${process.env.REACT_APP_API}cars`);

export const getDashboard = async () =>
    await axios.get(`${process.env.REACT_APP_API}dashboard`);
    
